import React, { useEffect, useState } from 'react';
import { Button } from "@/components/ui/button";
import { X, Info } from 'lucide-react';
import { setAnalyticsConsent } from '@/lib/analytics';

export default function CookieConsentBanner() {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Check if user has already made a choice
    const consentChoice = localStorage.getItem('analytics-consent');
    
    // If no choice has been made, show the banner
    if (consentChoice === null) {
      setIsVisible(true);
    } else {
      // Apply the saved choice
      setAnalyticsConsent(consentChoice === 'true');
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('analytics-consent', 'true');
    setAnalyticsConsent(true);
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('analytics-consent', 'false');
    setAnalyticsConsent(false);
    setIsVisible(false);
  };

  const handleDismiss = () => {
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 w-full z-50">
      <div className="bg-blue-800 text-white py-2 px-4 md:px-8">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <Info className="h-4 w-4 flex-shrink-0 hidden sm:block" />
            <p className="text-sm">
              We use cookies to analyze website traffic and optimize your experience.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={handleDecline}
              className="bg-transparent text-white border-white hover:bg-blue-700 hover:text-white h-8"
            >
              Decline
            </Button>
            <Button
              variant="default"
              size="sm"
              onClick={handleAccept}
              className="bg-white text-blue-800 hover:bg-gray-100 hover:text-blue-900 h-8"
            >
              Accept
            </Button>
            <button
              onClick={handleDismiss}
              className="text-white/80 hover:text-white ml-1"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}